import React, { useState, useEffect } from 'react';
import { getCompoundDetails } from '../api';

function CompoundDetail() {
  const [compoundId, setCompoundId] = useState('');
  const [compound, setCompound] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleSearch = async () => {
    if (!compoundId) {
      setError('Please enter a compound ID.');
      return;
    }
    setLoading(true);
    setError(null);
    setCompound(null);

    try {
      const data = await getCompoundDetails(compoundId);
      setCompound(data);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="compound-detail">
      <h2 className="compound-detail__title">Enter Compound ID to View Details</h2>
      <div className="compound-detail__search">
        <input
          type="text"
          value={compoundId}
          onChange={(e) => setCompoundId(e.target.value)}
          placeholder="Enter Compound ID"
          className="compound-detail__input"
        />
        <button 
          onClick={handleSearch} 
          disabled={!compoundId || loading}
          className="compound-detail__search-btn"
        >
          Search
        </button>
      </div>

      {loading && <p className="compound-detail__loading">Loading compound details...</p>}
      {error && <p className="compound-detail__error">Error: {error}</p>}
      {compound && (
        <div className="compound-detail__results">
          <h3 className="compound-detail__results-title">Compound Details (ID: {compound.compound_id})</h3>
          <div className="compound-detail__details">
            <p className="compound-detail__detail-item">
              <strong>SMILES:</strong> {compound.SMILES}
            </p>
            <p className="compound-detail__detail-item">
              <strong>Prediction:</strong> {compound.prediction}
            </p>
            <p className="compound-detail__detail-item">
              <strong>Confidence Score:</strong> {compound.confidence_score}
            </p>
            <p className="compound-detail__detail-item">
              <strong>Top Feature:</strong> {compound.top_feature}
            </p>
          </div>
        </div>
      )}
    </div>
  );
}

export default CompoundDetail;
